import { createSlice } from "@reduxjs/toolkit";

const initialLoaderState = {
  apiCallCount: 0,
};

export const loaderSlice = createSlice({
  name: "loaderSlice",
  initialState: initialLoaderState,
  reducers: {
    incApiCAll: (state) => {
      state.apiCallCount = state.apiCallCount + 1;
    },
    decApiCAll: (state) => {
      state.apiCallCount = state.apiCallCount - 1;
    },
  },
});
